module.exports = __webpack_public_path__ + "static/img/guaduan2.94f1779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/guaduan2.png
// module id = Gu8d
// module chunks = 24